import React, {ReactElement} from "react";
import * as PDFJS from 'pdfjs-dist';
//** 왜 node_modules에 있는걸 찾아가지 못해서 임시로 이렇게 처리 */
PDFJS.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.4.456/pdf.worker.js';
const CMAP_URL = "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.4.456/cmaps/";

const PAGE_SCALE = 1;

const readFile = (file: File): Promise<string | ArrayBuffer | null> => (new Promise((resolve, reject)=>{
    try {
        const fr = new FileReader();
        // fr.onload(()=>{
        //   resolve(fr!.result);
        // });
        fr.onload = function () {
            resolve(this.result);
        }
        fr.readAsDataURL(file);
    } catch (e) {
        reject(e);
    }
}));

const pdfDoc2Canvas = async (doc: PDFJS.PDFDocumentProxy) => {
    const pages: HTMLCanvasElement[] = [];
    for(let i = 0; i < doc.numPages; i++) {
        const page = await doc.getPage(i+1);
        const viewportOri = page.getViewport({scale: PAGE_SCALE});
        const {width: widthOri, height: heightOri} = viewportOri;

        const {innerWidth = 1920, innerHeight = 1080} = window;
        const standardOrientation = widthOri < heightOri;
        const pageStandard = standardOrientation ? widthOri : heightOri;
        const windowStandard = standardOrientation ? innerWidth : innerHeight;

        const pageRate = windowStandard / pageStandard;
        const viewport = page.getViewport({scale: pageRate});
        const {width, height} = viewport;

        const canvas: HTMLCanvasElement = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d');
        await page.render({canvasContext: (context as any), viewport}).promise;
        pages.push(canvas);
    }
    return pages;
}

const pdfDoc2CanvasPage = async (doc: PDFJS.PDFDocumentProxy, i: number) => {
    const page = await doc.getPage(i+1);
    const viewportOri = page.getViewport({scale: PAGE_SCALE});
    const {width: widthOri, height: heightOri} = viewportOri;

    const {innerWidth = 1920, innerHeight = 1080} = window;
    const standardOrientation = widthOri < heightOri;
    const pageStandard = standardOrientation ? widthOri : heightOri;
    const windowStandard = standardOrientation ? innerWidth : innerHeight;

    const pageRate = windowStandard / pageStandard;
    const viewport = page.getViewport({scale: pageRate});
    const {width, height} = viewport;

    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    await page.render({canvasContext: (context as any), viewport}).promise;
    return canvas;
}

// const pdfFile2Canvas = async (file: File): Promise<HTMLCanvasElement[]> => {
//     try {
//         const buffer = await readFile(file);
//         const doc = await PDFJS.getDocument(buffer as any).promise;
//         const pages = await pdfDoc2Canvas(doc);
//         return pages;
//     } catch (e) {
//         throw e;
//     }
// }

const pdfUrl2Canvas = async (url: string): Promise<HTMLCanvasElement[]> => {
    try {
        const doc = await PDFJS.getDocument({url: url, cMapUrl: CMAP_URL, cMapPacked: true, withCredentials:true}).promise;
        const pages = await pdfDoc2Canvas(doc);
        return pages;
    } catch (e) {
        throw e;
    }
}

const pdfUrl2Doc = async (url: string): Promise<PDFJS.PDFDocumentProxy> => {
    try {
        const doc = await PDFJS.getDocument({url: url, cMapUrl: CMAP_URL, cMapPacked: true, withCredentials:true}).promise;
        return doc;
    } catch (e) {
        throw e;
    }
}

export {pdfUrl2Canvas, pdfUrl2Doc, pdfDoc2CanvasPage};